/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCollapse/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCollapse({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCollapse",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCollapse.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-Z1kUyjy': alignSelf,'--mt-2-Z1kUyjy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1kUyjy': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1kUyjy': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1kUyjy': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1kUyjy': opacity,'--w-10-Z1kUyjy': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1kUyjy': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1kUyjy': fill,'--a-7-Z1kUyjy': isAnimated ? animation : "none",'--sd-8-Z1kUyjy': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1kUyjy': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCollapse.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.714 0h2.143v16H1.714A1.714 1.714 0 010 14.286V1.714C0 .768.768 0 1.714 0zm3.572 0v16h9c.947 0 1.714-.768 1.714-1.714V1.714C16 .768 15.232 0 14.286 0h-9zm6.956 4.625a.571.571 0 00-.608.079L8.206 7.56a.571.571 0 000 .878l3.428 2.857a.571.571 0 00.937-.439V5.143a.571.571 0 00-.329-.518z"
 style={{'--f-12-Z1kUyjy': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}